class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			/* Tezumi (2026-07): Shopify lists the most recently added line first,
			   so cartItems[0] keys the recommendations to the NEWEST addition
			   (add a matcha bowl -> immediately see whisk + matcha). */
			const productId = cartItems[0].dataset.productId;
			const base = `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${productId}&limit=${this.dataset.limit}`;
			/* Try the curated complementary pairings first (Search & Discovery
			   complementary_products metafield -- goes-with, e.g. tea set ->
			   loose leaf tea). Fall back to Shopify's default "related"
			   similarity for any product without a curated list, so the block
			   never goes empty. */
			this.fetchRecommendations(`${base}&intent=complementary`)
				.then(found => {
					if ( !found ) {
						return this.fetchRecommendations(`${base}&intent=related`);
					}
				})
				.catch(e=>{
					console.warn(e);
				})
		}
	}

	fetchRecommendations(url){
		return fetch(url)
			.then(response => response.text())
			.then(text => {
				const innerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-js-cart-recommendations-performed]');
        if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
        	this.innerHTML = innerHTML.innerHTML;
        	return true;
        }
        return false;
			})
	}
}
customElements.define('cart-recommendations', CartRecommendations);
